import { useOidcStore } from "vue3-oidc";
import { Configuration } from "@socotec.io/document-sdk";
import {
  Configuration as UserManagementConfiguration,
  AgenciesApi,
  UsersApi,
} from "@socotec.io/user-management-sdk";

const tokenGetter = () => {
  return useOidcStore().state.value.token;
};

const bearerTokenGetter = () => `Bearer ${useOidcStore().state.value.token}`;

const documentConfig = new Configuration({
  basePath: import.meta.env.VITE_APP_DOCUMENT_REST_API_URL,
  accessToken: tokenGetter,
});

const userManagementConfig = new UserManagementConfiguration({
  basePath: import.meta.env.VITE_APP_USER_MANAGEMENT_REST_API_URL,
  accessToken: bearerTokenGetter,
});

// Centralized user-management REST API instances
const agenciesApi = new AgenciesApi(userManagementConfig);
const usersApi = new UsersApi(userManagementConfig);

export { documentConfig, userManagementConfig, agenciesApi, usersApi };
